import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Route shell. Definition and guards only — the form lives in a feature.
 *
 * The route sits inside `_authenticated` so the parent layout's
 * `beforeLoad` ensures the user has a session before enrolment runs.
 * Fortify's `password.confirm` middleware is the second gate; the form
 * itself asks for the current password before the QR step if the
 * confirmation window has expired.
 */
export const Route = createFileRoute('/_authenticated/two-factor-setup')({
  beforeLoad: () => {
    throw redirect({ to: '/account/security' })
  },
})
